<template>
    <div class="forceElectricity">
        <div class="top">
            <div class="title">
                <h4>本月力调电费分析</h4>
                <div class="selectLoad">
                    <span>选择变电站/进线:</span>
                    <el-select v-model="value" placeholder="请选择">
                        <el-option
                            v-for="item in looplist"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="flex">
                <div class="box">
                    <div class="left">
                        <p>电费增减率</p>
                        <p v-if="percentage<1">电量减少百分比</p>
                        <p v-else>电量增加百分比</p>
                    </div>
                    <div class="right"><span>{{percentage}}</span>%</div>
                </div>
                <div class="box">
                    <div class="left">
                        <p>本月功率因数</p>
                        <p>高于考核标准</p>
                    </div>
                    <div class="right"><span>{{num}}</span></div>
                </div>
                <div class="box">
                    <div class="left">
                        <p>考核标准</p>
                        <p>考核标准值</p>
                    </div>
                    <div class="right"><span>0.9</span></div>
                </div>
                <div class="box">
                    <div class="left">
                        <p>有功电量</p>
                        <p>本月累计(kWh)</p>
                    </div>
                    <!-- <div class="right"><span>{{mqttval('PA_total')}}</span></div> -->
                    <div class="right"><span>{{powerTotaldata}}</span></div>
                </div>
                <div class="box">
                    <div class="left">
                        <p>无功电量</p>
                        <p>本月累计(kvarh)</p>
                    </div>
                    <!-- <div class="right"><span>{{mqttval('PR_total')}}</span></div> -->
                    <div class="right"><span>{{powerReactive}}</span></div>
                </div>
            </div>
        </div>
        <div class="charts">
            <h4>力调电费分析</h4>
            <div class="concent row-center">
                <div class="chartCon">
                    <charts id="chartCon" :option="chartConOption"></charts>
                </div>
                <div class="attention">
                    <div class="blue">
                        <span></span>月功率因数
                    </div>
                    <div class="blue">
                        <span></span>考核标准
                    </div>
                    <div class="attent">
                        注意：依据功率因数分级力调电费的增减，功率因数高于 标 准 时 <span class="green"> 减收 </span>电费，低于标准时<span class="red">增收</span>电费
                    </div>
                </div>
            </div>
            
        </div>
    </div>

</template>


<script>
import charts from "../../../components/Energy/charts";
import {
    subscribe,
    unsubscribe,
    subscribeByNodes
} from "../../../mqtt/index";
import {
    chainIndex
} from "../../../api/linkindex";
import { floatFormat } from "../../../util/MathUtil";
import {INFLUX_QUERY,powertotal,powerReactive} from "../../../api/power"
import {
    perDay,
    perMonth,
    perYear,
    nextDay,
    monthStart,
    yearStart,
    monthEnd,
    yearEnd,
    nextMonth,
    nextYear,
    dateFormat,
    dayStart,
    dayEnd,
} from "../../../util/DateUtil";
export default {
    components: {
        charts
    },
    data(){
        return {
            looplist: [],
            value: '',
            xdata:[],
            currentLoop:{},
            loading:true,
            date:new Date(),
            chartData:[],
            num:0,
            powerTotaldata:0,
            powerReactive:0,
        }
    },
    computed:{
        percentage(){
            let num = Number(this.num)
             if(num>=0.95&&num<=1){
                return 0.75
            }else if(num>=0.90&&num<0.95){
                let fee = 0.00
                let ss = (num-0.90).toFixed(2).split('0')[2]
                for (let index = 0; index < ss; index++) {
                    fee+=0.15
                }
                return fee.toFixed(2)
            }else if(num<=0.89){
                let fee = 0.5
                let ss = (0.89-num).toFixed(2).split('.')[1]
                for (let index = 0; index < ss; index++) {
                    fee+=0.5
                }
                return fee.toFixed(2)
            }else{
                return '--'
            }
        },
        chartConOption(){
            return{
                color: ["#0D94FF", "#5AD8A6", "#E8684A", "#5D7092"],
                tooltip: {
                trigger: "axis",
                },
                legend: {
                orient: "vertical", //垂直显示
                y: "10%", //延Y轴居中
                x: "right", //居右显示
                icon: "rect",
                itemWidth: 10,
                itemHeight: 10,
                textStyle: {
                    fontSize: 15,
                    fontWeight: 800,
                },
                },
                grid: {
                left: "1%",
                right: "1%",
                bottom: "1%",
                top: "1%",
                containLabel: true,
                },
                xAxis: {
                type: "category",
                boundaryGap: false,
                data: this.xdata,
                splitLine: {
                    show: true,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                    color: "#CCCCCC",
                    width: 1,
                    type: "solid",
                    },
                },
                axisLabel: {
                    //x轴文字的配置
                    show: true,
                    textStyle: {
                    color: "#999999",
                    },
                },
                },
                yAxis: {
                    type: "value",
                    name: "kWh",
                    // max:1,
                    // minInterval: 1,
                    // interval:0.025
                },
                series: [{
                    data:this.chartData,
                    type: 'line',
                    smooth: true,
                     markLine : {   //添加警戒线
                        symbol:"none",               //去掉警戒线最后面的箭头
                        name:"警戒线",
                        silent:true,
                        label:{
                            position:"insideEndTop",         //将警示值放在哪个位置，三个值“start”,"middle","end"  开始  中点 结束
                            formatter: "考核标准线",
                            color:"#F6BD16",
                            fontSize:14
                        },
                        data : [{
                            silent:true,             //鼠标悬停事件  true没有，false有
                            lineStyle:{               //警戒线的样式  ，虚实  颜色
                                color:"#F6BD16"
                            },
                            name: '考核标准线',
                            yAxis: 0.9
                        }]
                    }
                }],
            };
        },
        mqttval() {
            return this.getMqttVal(this.$store.getters.mqttVal);
        },
    },
    watch:{
        value(n,o){
            this.currentLoop =  this.looplist.filter(e=>e.loopName==n)[0]
            this.LoopData();
            subscribe([this.currentLoop.subLoopUrl]);
        }
    },
    mounted(){
        for(let i = 0; i <= 30; i++){
            this.xdata.push(i+1+'日')
        }
        this.getLooplist();
        this.getpower();
        this.getpowerReactive();

    },
    methods:{
        async getpower() {
            let start = monthStart(new Date())
            let end = monthEnd(new Date())
            let response = await powertotal(this.$store.state.project.currentProject.projectId,start,end);
            this.powerTotaldata = response.data.data.total.toFixed(2);
        },
        async getpowerReactive() {
            let start = monthStart(new Date())
            let end = monthEnd(new Date())
            let response = await powerReactive(this.$store.state.project.currentProject.projectId,start,end);
            this.powerReactive = response.data.data.total.toFixed(2);
        },
        getFirstDayOfMonth (date) {
            date.setDate(1);
            return dateFormat(date);
        },
        async LoopData(){
            this.loading = true
            this.chartData = []
            let ids = [this.currentLoop.loopId];
            let start
            let end
            let group="1d"
            
            start = monthStart(this.date)
            end = monthEnd(this.date)
            let res = await INFLUX_QUERY(ids, start, end, group,["PF"])
            let influxData = res.data.data.influxData
            let data = []
            let num =0
            let day = 0
            if(JSON.stringify(influxData.results[0])!= "{}"){
                influxData.results[0].series[0].values.forEach(val => {
                    if(val[4]!=null){
                        data.push(floatFormat(val[1],2));
                        let evel = val[1].toFixed(2)
                        num+=Number(evel)
                        day++
                    }else{
                        data.push('-')
                    }
                
                })
                this.num = Number(num/day).toFixed(2);
                this.chartData = data
                this.loading = false
            }else{
                this.num = '--'
            }
        },
        getMqttVal(f) {
            let currentLoop = this.currentLoop
            return (k, m) => {
                if (currentLoop && k) {
                    k = currentLoop.subLoopUrl + "/" + k;
                    let mqttVal = f(k);
                    mqttVal = floatFormat(mqttVal, 2);
                    if (typeof mqttVal === "object") {
                        return mqttVal;
                    }
                    return mqttVal !== undefined && !isNaN(mqttVal) ? mqttVal : "--";
                } else {
                    return "--";
                }
            };
        },
        async  getLooplist(){
            let response = await chainIndex.loopAll(this.$store.state.project.currentProject.projectId);
            this.looplist = response.data.data.loops.map(e => {
                e.label=e.loopNam;
                e.value=e.loopName;
                return e
            }) || [];
            this.currentLoop = this.looplist[0]
            this.value = this.looplist[0].loopName
            this.LoopData();
            subscribe([this.currentLoop.subLoopUrl]);
        },
    }
}
</script>

<style lang="less" scoped>
    .forceElectricity{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        .top{
            width: 100%;
            height: 22vh;
            background-color: #fff;
            .title{
                padding: 18rem 26rem 0;
                font-size: 20rem;
                color: #333;
                overflow: hidden;
                h4{
                    padding-top: 9rem;
                    font-weight: bold;
                    float: left;
                    font-size: 18rem;
                }
                .selectLoad{
                    font-weight: 400;
                    float: right;
                    span{
                      margin-right: 17rem;
                    }
                }
            }
            .flex{
                width: 100%;
                padding-top: 19rem;
                display: flex;
                justify-content: space-evenly;
                .box{
                    width: 18%;
                    height: 140rem;
                    background: #F5F7F9;
                    border-radius: 8rem;
                    overflow: hidden;
                    .left{
                        float: left;
                        padding: 35rem 0 0 22px;
                        p:nth-child(1){
                            font-size: 20rem;
                            font-weight: bold;
                            color: #333;
                            padding-bottom: 16rem;
                        }
                        p:nth-child(2){
                            font-size: 18rem;
                            font-weight: 400;
                            color: #666;
                        }
                    }
                    .right{
                        float: left;
                        width: 7vw;
                        padding-top:70rem;
                        text-align: center;
                        font-weight: bold;
                        color:#0D94FF ;
                        display: inline-block;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        span{
                            font-size: 30rem;
                        }
                    }
                }
                .box:nth-child(1){
                    .right{
                        color: #68D86A;
                    }
                }
            }
        }
        .charts{
            // margin-top: 12rem;
                width: 100%;
                height: 66vh;
            // height: calc(100% - 245rem);
            background-color: #fff;
            padding: 25rem 40rem 0 26rem;
            h4{
              font-size: 18rem;
              font-weight: bold;
              color: #333;
              padding-bottom: 20rem;
            }
            .concent{
                width: 100%;
                height: 92%;
                overflow: hidden;
                .chartCon{
                    float: left;
                    width: calc(100% - 190rem);
                    height: 100%;
                }
                .attention{
                    float: right;
                    width:180rem ;
                    // height: 100%;
                    // padding:150rem 0 0 20rem;
                    padding: 0 20px;
                    .blue{
                        padding-bottom:23rem;
                        font-size: 20rem;
                        font-weight: bold;
                        color:#333;
                        span{
                            display: inline-block;
                            width: 8rem;
                            height: 8rem;
                            background-color: #5B8FF9;
                            margin-right: 10rem;
                            vertical-align: middle;
                        }
                    }
                    .blue:nth-child(2){
                        span{
                            background-color: #F6BD16;
                        }
                    }
                    .attent{
                        font-size: 16rem;
                        font-weight: 400;
                        color: #999;
                        span:nth-child(1){
                            color:#68D86A;
                        }
                        span:nth-child(2){
                            color:#FD4238;
                        }
                    }
                }
            }
        }
    }

</style>
